import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import actions from 'actions';

const {
  loadBranchesSaga
} = actions;

class BranchInput extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    loadBranches: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.array,
    branches: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    selectProps: PropTypes.object
  };

  static defaultProps = {
    label: ''
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadBranches();
  }

  render() {
    const {
      value,
      onChange,
      errors,
      branches,
      label,
      placeholder = 'Branch',
      selectProps = {}
    } = this.props;
    return (
      <div className="col s12">
        <p className="input_country">{label}</p>
        <Select
          options={this.props.branches}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...selectProps}
        />
        <div style={{ color: 'red', fontSize: '0.875rem' }}>
          {(errors || []).join('. ')}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    branches: state.suggestions.branch.values
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadBranches: () => dispatch(loadBranchesSaga())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchInput);



// WEBPACK FOOTER //
// ./src/containers/Input/BranchInput.jsx